import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "cl_access_token";

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

// Public axios for unauthenticated calls (landing pages) - no interceptors
export const apiPublic = axios.create({
  baseURL: `${BASE}/api`,
});

// Attach Bearer token from localStorage on every request as fallback to cookies
api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// On 401, clear stored token and bounce to /login (unless already there)
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    // /auth/me anonymous calls are expected - silence them
    if (status === 401 && url.includes("/auth/me")) {
      return Promise.reject(error);
    }
    if (status === 401 && !url.includes("/auth/login")) {
      localStorage.removeItem(TOKEN_KEY);
      const p = typeof window !== "undefined" ? window.location.pathname : "";
      const isPublic = p.startsWith("/login") || p.startsWith("/assinar") || p.startsWith("/verificar") || p.startsWith("/com/") || p.startsWith("/cliente");
      if (!isPublic) {
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);

export function saveToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

// Eletros: URL autenticada de imagem servida pelo backend (img nao envia header)
export function eletrosMediaUrl(path) {
  if (!path) return "";
  const t = localStorage.getItem(TOKEN_KEY) || "";
  return `${BASE}/api/eletros/media/${path}?auth=${encodeURIComponent(t)}`;
}

export function formatErr(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function brl(n) {
  const v = Number(n || 0);
  return v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function formatDate(iso) {
  if (!iso) return "-";
  const s = String(iso);
  // Data pura YYYY-MM-DD (vencimentos): formata manualmente, SEM conversao de fuso (UTC)
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  // Timestamp com hora (ex: created_at): converte para o fuso local normalmente
  try { return new Date(s).toLocaleDateString("pt-BR"); } catch { return s; }
}

export function formatDateTime(iso) {
  if (!iso) return "-";
  try { return new Date(iso).toLocaleString("pt-BR"); } catch { return iso; }
}

export function maskCPF(c) {
  if (!c) return "";
  const d = c.replace(/\D/g, "").padStart(11, "0").slice(0, 11);
  return `${d.slice(0,3)}.${d.slice(3,6)}.${d.slice(6,9)}-${d.slice(9,11)}`;
}

export function classifyLabel(score) {
  const s = Number(score || 0);
  if (s >= 850) return { label: "Ouro", key: "ouro" };
  if (s >= 700) return { label: "Bom", key: "bom" };
  if (s >= 500) return { label: "Medio", key: "medio" };
  if (s >= 300) return { label: "Risco", key: "risco" };
  return { label: "Restrito", key: "restrito" };
}
